export const availableApps = [
    {
        title: "Gestor de Dados",
        path: 'datamanager',
        glyph: "hdd",
        defaultRoute: "lines"
    },
    {
        title: "Horários à Paragem",
        path: 'bussched',
        glyph: "list",
        defaultRoute: "schedules/generate"
    },
    {
        title: "Mapas Esquemáticos",
        path: 'busmap',
        glyph: "file",
        defaultRoute: "new"
    },
    {
        title: "Spider Maps",
        path: 'spidermap',
        glyph: "file",
        defaultRoute: "new"
    },
    {
        title: "Placas de Paragem",
        path: 'stopplates',
        glyph: "credit-card"
    }
];

export class AppManager {
    getApp(path) {
        return availableApps.filter(function (app) {
            return app.path === path;
        })[0];
    }
}

export const appManager = new AppManager();



// WEBPACK FOOTER //
// ./src/app/AppManager.js